import { History } from 'history';
import { combineReducers } from 'redux';
import { RouterState, connectRouter } from 'connected-react-router';

import tenantReducer, { ITenantReducer } from './tenant.reducer';
import projectReducer, { IProjectReducer } from './project.reducer';
import questionReducer, { IQuestionReducer } from './questions.reducer';
import authReducer, { IAuthenticationReducer } from './authentication.reducer';
import mediaReducer, { IMediaLibrary } from './mediaLibrary.reducer';
import conversationalReducer, {
    IConversationalReducer
} from './conversational.reducer';
import utilsReducer, { IUtilsReducer } from './utils.reducer';
import optionpackReducer, { IOptionPackReducer } from './optionpacks.reducer';
export interface ReduxState {
    router: RouterState;
}

/**
 * Creates a combination of all the reducers for the application
 * @param {History} history History object
 */
const rootReducer = (history: History) =>
    combineReducers<IApplicationState>({
        router: connectRouter(history),
        mediaReducer,
        conversationalReducer,
        authReducer,
        tenantReducer,
        projectReducer,
        questionReducer,
        utilsReducer,
        optionpackReducer
    });

export interface IApplicationState {
    router: RouterState;
    authReducer: IAuthenticationReducer;
    mediaReducer: IMediaLibrary;
    conversationalReducer: IConversationalReducer;
    projectReducer: IProjectReducer;
    tenantReducer: ITenantReducer;
    questionReducer: IQuestionReducer;
    utilsReducer: IUtilsReducer;
    optionpackReducer: IOptionPackReducer;
}

export default rootReducer;
